module.exports = __webpack_public_path__ + "static/img/1-1-1.5538d886.jpg";